import { CgArrowLeft } from "react-icons/cg";
import { inactiveItens } from "../../../../../../../../../../theme";
import { LicenseIcon } from "../../../../../../../../../../components/SvgComponents/Icons/LicenseIcon";
import { PassportIcon } from "../../../../../../../../../../components/SvgComponents/Icons/PassportIcon";
import { RGIcon } from "../../../../../../../../../../components/SvgComponents/Icons/RGIcon";

export interface IStartDocuments {
  onNext: (document_type: "rg" | "passport" | "license") => void;
  goBack: () => void;
}

export const SelectDocumentType: React.FC<IStartDocuments> = ({
  goBack,
  onNext,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
        flex: 1,
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: 5,
              position: "relative",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <div
              style={{ position: "absolute", left: 0 }}
              className="pointer"
              onClick={() => goBack()}
            >
              <CgArrowLeft color={inactiveItens.light} size={20} />
            </div>
            <div>Documentação</div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 20,
            flex: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ fontSize: 18, fontWeight: "bold" }}>
              Cadastre um documento
            </div>
            <div
              style={{
                fontSize: 14,
                color: "#5B5B5B",
                textAlign: "center",
                width: 300,
              }}
            >
              Selecione uma das opções de documento de identificação para
              cadastrar.
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: 16,
            }}
          >
            <div
              style={{
                display: "flex",
                padding: 16,
                borderRadius: 8,
                gap: 10,
                border: "1px solid #8D8D8D",
                cursor: "pointer",
              }}
              onClick={() => onNext("license")}
            >
              <LicenseIcon />
              <div style={{ color: "#3A3A3A", fontWeight: "bold" }}>
                Carteira de Habilitação
              </div>
            </div>
            <div
              style={{
                display: "flex",
                padding: 16,
                borderRadius: 8,
                gap: 10,
                border: "1px solid #8D8D8D",
                cursor: "pointer",
              }}
              onClick={() => onNext("passport")}
            >
              <PassportIcon />
              <div style={{ color: "#3A3A3A", fontWeight: "bold" }}>
                Passaporte
              </div>
            </div>
            <div
              style={{
                display: "flex",
                padding: 16,
                borderRadius: 8,
                gap: 10,
                border: "1px solid #8D8D8D",
                cursor: "pointer",
              }}
              onClick={() => onNext("rg")}
            >
              <RGIcon />
              <div style={{ color: "#3A3A3A", fontWeight: "bold" }}>
                Documento de Identidade
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
